import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button } from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { OrderWithItems } from 'common-models';
import { FC } from 'react';
import { Link } from 'react-router-dom';

type OrdersListProps = {
    orders: Array<OrderWithItems>;
};

/**
 * OrdersList component - displays a list of orders in the admin interface
 * with separate sections for open and closed orders.
 */
const OrdersList: FC<OrdersListProps> = ({ orders }) => {

    function renderOrder(x: OrderWithItems): React.JSX.Element {
        return <Grid key={x.id} container className={classes.cartFrame}>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>{x.createdTime.toISOString()}</Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>{x.items.length} items</Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>Total: SEK {x.totalSum} ({x.totalSum * 1.25} incl VAT)</Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                <Grid size="auto">{x.isOpen ? 'Open' : 'Closed'}</Grid>{x.currentState}</Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}><Button
                variant='text'
                value={x.id}
            >
                <DeleteForeverIcon />
            </Button>
                <Link to={`/orders/${x.id}`}>View order page</Link>
            </Grid>
        </Grid>;
    }

    return (
        <>
            <Grid container>
                <h1>Orders</h1>
            </Grid>
            <Grid container>
                <h2>Open orders</h2>
                {
                    orders.filter(x => x.isOpen).map(x => renderOrder(x))
                }
            </Grid>
            <Grid container>
                <h2>Closed orders</h2>
                {
                    orders.filter(x => !x.isOpen).map(x => renderOrder(x))
                }
            </Grid>
        </>
    );
};

const PREFIX = 'OrdersList';
const classes = {
    cartFrame: `${PREFIX}-cartFrame`,
};

const Root = styled('div')(({ theme }) => ({
    [`&.${classes.cartFrame}`]: {
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: theme.palette.text.secondary,
        borderRadius: '0.3rem',
        margin: '0.5rem'
    },
}));

export { OrdersList };
